import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import {
  IListingOptimisationPartsRequest,
  IListingReviewedResponse,
} from "../models/listingOptimisation/IListingReview";

/**
 * The eBay Optimisation queue's "reviewed" stamp. Marking a listing reviewed records who looked
 * at it and when, so the queue can hide it for a while (hideReviewedWithinDays) - it changes
 * nothing on eBay. One call covers a single row and a bulk selection alike.
 */
export default function useListingReview(componentName = "useListingReview") {
  const { post } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const markReviewed = useMutation(
    (partDataIds: string[]) =>
      post<IListingOptimisationPartsRequest, IListingReviewedResponse>("/listingoptimisation/reviewed", {
        partDataIds,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
        queryClient.invalidateQueries(["partDetails"]);
      },
    }
  );

  return {
    markReviewed,
  };
}
